import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CONCEPT_DOMAIN,
  CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT,
  CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT,
  conceptApi,
} from "api/conceptApi";

import CustomModal from "components/common/CustomModal";
import Link from "components/common/Link";
import { useCallback, useState } from "react";
import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { HOME_DOMAIN, HOME_TASK_LIST_ENDPOINT } from "../../../api/homeApi";
import useGoHomeWeb from "../../../hooks/useGoHomeWeb";

export default function ResetAutomaticThoughtButton({
  automaticThoughtId,
  thoughtRecordKey,
  isForValue = false,
}: {
  automaticThoughtId: string;
  thoughtRecordKey?: string;
  isForValue?: boolean;
}) {
  const queryClient = useQueryClient();
  const patientState = useRecoilValue(patientAtom);
  const [open, setOpen] = useState(false);
  const { goHome } = useGoHomeWeb();

  const resetAutomaticThoughtQueryFn = useCallback(
    () =>
      conceptApi.resetAutomaticThought(
        patientState?.patientId!!,
        `${automaticThoughtId}`,
        isForValue
      ),
    [patientState?.patientId, automaticThoughtId, isForValue]
  );

  const { mutate: resetAutomaticThought } = useMutation(
    resetAutomaticThoughtQueryFn,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          CONCEPT_DOMAIN,
          CONCEPT_NOTE_AUTOMATIC_THOUGHT_LIST_ENDPOINT,
          patientState?.patientId,
        ]);

        if (thoughtRecordKey) {
          queryClient.invalidateQueries([
            CONCEPT_DOMAIN,
            CONCEPT_NOTE_AUTOMATIC_THOUGHT_DETAIL_ENDPOINT,
            patientState?.patientId,
            thoughtRecordKey,
          ]);
        }
        queryClient.invalidateQueries([
          HOME_DOMAIN,
          HOME_TASK_LIST_ENDPOINT,
          patientState?.patientId,
        ]);
      },
    }
  );

  const handleReset = () => {
    resetAutomaticThought();
    setOpen(false);
    goHome();
  };

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <Link text="초기화" opacity={1} textColor="primary.solid" />
      </div>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title={
          "이 자동적 사고를 초기화할까요? 진행 중인 활동지들은 모두 초기화됩니다."
        }
        subtitle={""}
        actions={[
          {
            label: "초기화하기",
            variant: "Solid",
            color: "danger",
            onClick: () => {
              handleReset();
            },
          },
        ]}
      />
    </>
  );
}
